var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYouTubeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5219 14.2844C47.5219 14.2844 47.0531 10.975 45.6094 9.52188C43.7812 7.60938 41.7375 7.6 40.8 7.4875C34.0875 7 24.0094 7 24.0094 7H23.9906C23.9906 7 13.9125 7 7.2 7.4875C6.2625 7.6 4.21875 7.60938 2.39062 9.52188C0.946875 10.975 0.4875 14.2844 0.4875 14.2844C0.4875 14.2844 0 18.175 0 22.0563V25.6937C0 29.575 0.478125 33.4656 0.478125 33.4656C0.478125 33.4656 0.946875 36.775 2.38125 38.2281C4.20937 40.1406 6.60938 40.075 7.67813 40.2812C11.5219 40.6469 24 40.7594 24 40.7594C24 40.7594 34.0875 40.7406 40.8 40.2625C41.7375 40.15 43.7812 40.1406 45.6094 38.2281C47.0531 36.775 47.5219 33.4656 47.5219 33.4656C47.5219 33.4656 48 29.5844 48 25.6937V22.0563C48 18.175 47.5219 14.2844 47.5219 14.2844ZM19.0406 30.1094V16.6187L32.0062 23.3875L19.0406 30.1094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeIcon);
export default __webpack_public_path__ + "static/media/YouTube-icon.909a149e0e9d0c8dbb28b6716b93015b.svg";
export { ForwardRef as ReactComponent };